import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/core';
import { rgba, darken } from 'polished';

import mq from '../styles/breakpoints';
import { colors } from '../../tailwind';

export const zoom = keyframes`
from {
  transform: scale(1);
}
to {
  transform: scale(1.1);
}
`;

export const LogoBig = styled.div`
  ${tw`relative flex justify-center items-center overflow-hidden`}
  height: 300px;
  padding: 1rem;
  /* background: linear-gradient(to bottom right, #0b8793, #360033); */

  img {
    ${tw`absolute`}
    width: 250px;
    /* top: 50%; */
  }
`;

export const Hero = styled.section`
${tw`relative flex items-end text-white overflow-hidden`}
z-index: 2;
padding: 0 0 140px;
min-height: 1000px;
${mq.sm} {
  min-height: 100vh;
}
text-shadow: 1px 1px 30px ${rgba('#000', 0.5)}, 0 1px 2px ${rgba('#000', 0.3)};
background: center/cover no-repeat;
background-image: url(${require('../images/bgs/hero2.jpg')});

${mq.sm} {
  background-position: 70% center;
}

/* &:after {
  ${tw`absolute pin`}
  z-index: -1;
  content: '';
  background-image: linear-gradient(to top, ${rgba('#000', 0)} 50%, ${rgba(
  '#000',
  0.5
)}),
    linear-gradient(to bottom, ${rgba('#000', 0)} 20%, ${rgba('#000', 0.5)});
} */
`;

export const Section = styled.section`
  ${tw`relative overflow-hidden`}
  padding: 8rem 0;
  ${mq.sm} {
    padding: 4rem 0;
  }
  z-index: 1;

  p {
    ${tw`mb-8`}
    line-height: 1.75;
  }

  blockquote {
    ${tw`italic font-serif relative`}
    font-size: 1.75em;

    &:before {
      content: '\\201C';
      font-size: 3.5em;
      position: absolute;
      left: -0.4em;
      top: -0.35em;
      opacity: 0.25;
      font-style: normal;
    }
  }
`;

export const About = styled(Section)`
${tw`text-xl`}
/* ${tw`text-white`}
background: #1f9fa8; */
`;

export const Album = styled(Section)`
  ${tw`py-20`}
`;

export const BlurBg = styled.div`
${tw`w-screen absolute pin`}
user-select: none;
z-index: -2;
filter: blur(35px);
transform: scale(1.75);

&:after {
  content: '';
  ${tw`absolute pin`}
  background: ${(p) => p.color};
  opacity: ${(p) => p.opacity || 0.5};
}

.gatsby-image-wrapper {
  position: absolute !important;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
`;

export const Tv = styled(Section)`
  ${tw`py-20 bg-primary text-white`}
  background: top/cover no-repeat;
  background-image: url(${require('../images/bgs/red.jpg')});
  ${mq.sm} {
    background-position: 60% center;
  }
`;

export const MM = styled(Section)`
  ${tw`py-20 bg-white text-grey-darker`}
  /* padding-top: 15rem; */
  background: center/cover no-repeat;
  /* background-image: url(${require('../images/book-mockup-bg.jpg')}); */
  ${mq.sm} {
    background-position: 60% center;
  }
`;

export const Book = styled(Section)`
  ${tw`py-10 bg-primary text-white`}
  padding-top: 15rem;
  background: center/cover no-repeat;
  background-image: url(${require('../images/book-mockup-bg.jpg')});
  ${mq.sm} {
    background-position: 60% center;
  }
`;

export const Ending = styled(Section)`
  ${tw`py-20 text-xl bg-secondary text-black`}
  background: #DFC413 center/cover no-repeat;
  background-image: url(${require('../images/bgs/footer.jpg')});

  ${mq.sm} {
    background-image: none;
  }

  a {
    ${tw`text-black font-bold mr-4`}
    &:after {
      background: #000;
      opacity: 0.5;
    }
  }
`;

export const CTA = styled(Link)`
  ${tw`text-lg uppercase font-block font-black text-white tracking-xwide leading-none bg-black hover:bg-primary rounded-full p-4 px-8`}
  transition: all 0.1s ease;

  :active {
    box-shadow: none;
    transform: translateY(0);
  }

  :after {
    display: none;
  }
`;

export const CTAA = styled.a`
  ${tw`text-lg uppercase font-block font-black text-white tracking-xwide leading-none bg-black hover:bg-primary rounded-full p-4 px-8`}
  transition: all 0.1s ease;

  :active {
    box-shadow: none;
    transform: translateY(0);
  }

  :after {
    display: none;
  }
`;

export const TitleSerif = styled.h3`
  ${tw`md:text-5xl text-4xl font-serif font-bold leading-none italic`}
  line-height: 0.9;

  span {
    ${tw`relative block font-light tracking-wide opacity-75`}
    /* left: 0.4em; */
  font-size: 0.45em;
  }
`;

export const TitleSans = styled.h3`
  ${tw`md:text-6xl text-5xl font-sans font-semibold tracking-tight leading-none`}
  line-height: 0.9;

  span {
    ${tw`relative block font-medium tracking-wide opacity-75`}
    /* left: 0.4em; */
  font-size: 0.4em;
  }
`;

export const Video = styled.div`
  ${tw`rounded mr-3 flex flex-col justify-center items-center p-3 cursor-pointer`}
  background: ${rgba('#000', 0.1)};
  transition: all 0.3s ease;

  i {
    ${tw`text-3xl`}
  }

  &:hover {
    background: ${rgba('#000', 0.3)};
  }

  h5 {
    ${tw`mt-2`}
  }
`;

export const StreamLinks = styled.div`
  ${tw`inline-flex`}

  a {
    ${tw`text-2xl rounded flex flex-col justify-center items-center p-2 cursor-pointer text-white block`}
  }
`;
